// extracted by mini-css-extract-plugin
export default {"branches-wrapper":"branches_branches-wrapper__zPs7x","header":"branches_header__hPjL3","header__title":"branches_header__title__C64nF"};